export default __webpack_public_path__ + "static/media/goopter-ecommerce-guidance-resources.aa3f515b.jpg";